// require('./quickMobileScroll'); // quik_scroll disabled — legacy mobile scroll indicator
require('./components/ui-components/modal-bootstrap-v3.4.1');
require('./components/ui-components/animateOnScoroll');

const TooltipPositioning = require('./components/ui-components/tooltip.js').TooltipPositioning;
const simpleAccordion = require('./components/ui-components/simpleAccordion').simpleAccordion;
const lazyImages = require('./components/ui-components/LazyLoad.js').lazyImages;
const videoPopup = require('./components/ui-components/VideoPopup').videoPopup;

const {onModeEnter, onModeLeave, getMode} = require('./media.js');
const StickyHeader = require('./StickyHeader.js').StickyHeader;
const StickyTabs = require('./StickyHeader.js').StickyTabs;
const FooterAccordion = require('./FooterAccordion.js').FooterAccordion;
const Icons = require('./Icons.js').Icons;
const effects = require('./effects.js');

const debug = require('./debug.js');
// const nailTab = require('./nail-salon-lending/tab.js');
const support = require('./support.js');
const $ = require("jquery");
//const schedulingSoftwarePage = require('./scheduling-software/main.js'); // because displayed error on other pages !!!!!!
const Login = require('./login/login').Login;
const { initSimpleTabs } = require("./components/ui-components/tab");
const rudderstack = require('./analytics/rudderstack/rudderstack.js').rudderstack;
const { initRudderstackAnalytics } = require('./analytics/rudderstack/events.js');
import { initEagerComponents, initLazyComponents } from './components/lazyInitializer';

// we do not need it for a while
//global.Registration = require('./registration/registration').Registration;
//console.log(Login);
global.Login = Login;
global.Feedback = require('./feedback/feedback').Feedback;
global._t = _t;
global.rudderstack = rudderstack;

//console.log('console.log in app.js')

initEagerComponents();
initLazyComponents();

new StickyHeader();
new StickyTabs();
new FooterAccordion();
new Icons();
if ($('.templates__slider, .section--reviews-carousel, .reviews--slider-v2').length) {
    Promise.all([
        import(/* webpackChunkName: "slick-sliders" */ './TemplatesSlider.js'),
        import(/* webpackChunkName: "slick-sliders" */ './ReviewsSlider.js'),
    ]).then(function(mods) {
        var TemplatesSlider = mods[0].TemplatesSlider;
        var ReviewsSlider   = mods[1].ReviewsSlider;
        var ReviewsSlider_v2 = mods[1].ReviewsSlider_v2;
        if ($('.templates__slider').length) new TemplatesSlider();
        if ($('.section--reviews-carousel').length) new ReviewsSlider();
        if ($('.reviews--slider-v2').length) new ReviewsSlider_v2();
    });
}
new simpleAccordion();

// Handle lazy loading images
lazyImages();
// Handle lazy loading youtube video in popups
videoPopup();

// Rudderstack Analytics tracking
initRudderstackAnalytics();

support.supportChat();
new TooltipPositioning();

effects.addRippleToButton($('.btn, li.to-previous-step'));

debug.showScreenSize();

// Deferred backdrop-filter: apply 500ms after window.load so GPU compositing layers
// are not created during FCP/LCP/TBT measurement window.
window.addEventListener('load', function () {
	setTimeout(function () {
		document.body.classList.add('is-page-ready');
	}, 500);
}, { once: true, passive: true });


var menuWasOpen = false;

$('.header--togg-menu').click(function () {
    menuWasOpen = !menuWasOpen;
    closeMenu();
});

$('.morph-shape, .header--mob-togg-menu, .sb-header--profile-toggler').click(function () {
    menuWasOpen = false;
    closeMenu();
});

initSimpleTabs($('.tab-switcher--header:not(.developer-tab-switch):not(.team-tab-switch)'));


function closeMenu() {
    if (menuWasOpen) {
        $('body').addClass('menu--opened');
        $('.header--togg-menu, .header .morph-shape').addClass('open');
		$('.main-nav').addClass('open');
    } else {
        $('body').removeClass('menu--opened');
        $('.main-nav').removeClass('open');
        $('.main-nav .menu--link-has-dropdown .submenu').removeClass('opened');
		$('.header--togg-menu, .morph-shape').removeClass('open');
    }
}

$(window).resize(function () {
    // g_heightHeader = $('.header .header--settings-block .header--settings-container').height();
    // g_windowHeight = $(window).height() - g_heightHeader;
    // g_windowHeightThird = (g_windowHeight / 3);
    // g_windowWidth = $(window).width();
    //setHeightForCategoryItem();

    if ($(window).width() > 768) {
        menuWasOpen = false;
        closeMenu();
    }
});



(function() {
	const BREAKPOINT = 768; // 🔹

	function relocateAccordionItems() {
		const accordionContainer = document.querySelector('.sb-header .accordion');
		const headerItems = document.querySelectorAll('.accordion-header__item [data-accordion]');
		if (!accordionContainer || !headerItems.length) return;

		if (window.innerWidth < BREAKPOINT) {
			headerItems.forEach(link => {
				const targetId = link.getAttribute('data-accordion');
				const targetBlock = document.querySelector(targetId);
				if (!targetBlock) return;

				const parentItem = link.closest('.accordion-header__item');
				const next = parentItem.nextElementSibling;
				if (!next || !next.isSameNode(targetBlock)) {
					parentItem.after(targetBlock);
				}
			});
		} else {
			const allItems = document.querySelectorAll('.sb-header .accordion-item');
			allItems.forEach(item => {
				if (!accordionContainer.contains(item)) {
					accordionContainer.appendChild(item);
				}
			});
		}
	}

	// Виклик при завантаженні
	document.addEventListener('DOMContentLoaded', relocateAccordionItems);

	// Виклик при ресайзі (debounce щоб не смикати часто)
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(relocateAccordionItems, 150);
	});

	// MutationObserver: якщо довантажили HTML пізніше
	// Guard prevents cascading reflows: DOM moves inside relocateAccordionItems()
	// would re-trigger the observer, causing window.innerWidth reads after each write.
	let relocating = false;
	const observer = new MutationObserver(() => {
		if (relocating) return;
		relocating = true;
		relocateAccordionItems();
		relocating = false;
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();




function reviewAccordion() {
	const slider = $('.reviews--slider');

	// авто-ID
	slider.find('.short-review').each(function (index) {
		const id = 'review-text-' + (index + 1);
		$(this).attr('id', id);
		$(this).find('.read-more').attr('aria-controls', id);
	});

	slider.on('click keydown', '.read-more', function (e) {
		if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) return;

		const btn = $(this);
		const review = btn.closest('.short-review');
		const isOpen = btn.hasClass('open');
		const sliderEl = $('.reviews--slider');

		e.preventDefault();

		// aria
		btn.attr('aria-expanded', !isOpen);

		// toggle UI
		btn.toggleClass('open');
		review.toggleClass('full-review');

		// close others
		slider.find('.read-more').not(btn)
			.removeClass('open')
			.attr('aria-expanded', 'false');

		slider.find('.short-review').not(review)
			.removeClass('full-review')
			.css('max-height', 76);

		// expand
		if (review.hasClass('full-review')) {
			review.animate({'max-height': review[0].scrollHeight + "px"}, {
				duration: 300,
				step: function () {
					sliderEl.slick('resize');
					sliderEl.slick("setOption", null, null, true);
				}
			});
		} else {
			review.animate({'max-height': 76}, {
				duration: 200,
				step: function () {
					sliderEl.slick('resize');
					sliderEl.slick("setOption", null, null, true);
				}
			});
		}

		// додаткові хелпери — важливо
		setTimeout(resizeReviewsCarousel, 50);
		setTimeout(resizeReviewsCarousel, 150);
		setTimeout(resizeReviewsCarousel, 350);

		function resizeReviewsCarousel() {
			sliderEl.slick('resize');
			sliderEl.find(".slick-slide").css("height", "auto");
			sliderEl.find(".slick-list").css("height", "auto");
		}
	});
}

reviewAccordion();

function openSubMenuOnTuch() {
    $('.header--navigation-menu-container').on('click', '.header--main-nav-mobile .menu--link-has-dropdown', function () {
        var get_data = $(this).data("submenu");
        var sub_menu = $(this).closest('.header--main-nav-mobile .main-nav--menu').find('#' + get_data);
        $(sub_menu).addClass('opened');
    });
}

openSubMenuOnTuch();

function goToPrevMenuOnTuch() {
    $('.header--navigation-menu-container ').on('click', '.header--main-nav-mobile .submenu .to-previous-step', function (e) {
        $('.submenu').removeClass('opened');
        e.stopPropagation();
    })
}

goToPrevMenuOnTuch();

function smoothScrollAnchorLinks() {
    $('.anchor-link').click(function (e) {
        e.preventDefault();
        $('.anchor-link').removeClass('active');

        var target = $($(this).attr('href'));
        if (!target.length) return;

        var offset_value = $(this).data('offset') || 0;
        if (getMode() != 'desktop') offset_value = offset_value - $(this).height();
        if (getMode() == 'mob') offset_value = 0;

        var scrollTo = target.offset().top - (offset_value > 0 ? offset_value : 0);
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = prefersReduced ? 0 : 800;

        var scrollDone = false;
        $('body, html').stop().animate({scrollTop: scrollTo}, duration, function () {
            if (scrollDone) return;
            scrollDone = true;

            var targetEl = target[0];
            var focusable = target
                .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                .filter(':visible')
                .first();

            if (focusable.length) {
                focusable[0].focus({preventScroll: true});
            } else {
                if (!targetEl.hasAttribute('tabindex')) {
                    targetEl.setAttribute('tabindex', '-1');
                }
                targetEl.focus({preventScroll: true});
            }
        });
    });
}

smoothScrollAnchorLinks();

function scrollToBlock(cur_block, callback, additionalOffset) {
    if ($(cur_block).length == 0) {
        return;
    }

    var isIn = checkIsIN();

    var additionalOffsetValue = additionalOffset;

    if (callback) callback(isIn);

    function checkIsIN() {
            var hT = cur_block.offset().top,
                hH = cur_block.outerHeight(),
                wH = $(window).height(),
                wS;

            if (additionalOffsetValue) {
                wS = $(window).scrollTop() + additionalOffsetValue;
            } else {
                wS = $(window).scrollTop();
            }


                return wS > (hT + hH - wH) && (hT > wS) && (wS + wH > hT + hH);
    }

    document.addEventListener('scroll', function () {
        if (checkIsIN()) {
            //console.log('in view');
            cur_block.addClass('in');
            if (!isIn) {
                if (callback) callback(true);
                isIn = true;
            }

        } else {
            //console.log('not in view');
            cur_block.removeClass('in');
            if (isIn) {
                if (callback) callback(false);
                isIn = false;
            }
        }
    }, {passive: true});
}

scrollToBlock($('#letter-block'));

scrollToBlock($('.worldwide--content-wrapper'), function (isIn) {
    var $mapPoints = $('.map-svg g path.st43');

    if (isIn) {
        $mapPoints.each(function (i) {
            var point = $(this);
            setTimeout(function () {
                point.removeClass('slideOutDown1').addClass('animated slideInDown1');
            }, i * 280);
        })

    } else {
        $mapPoints.each(function (i) {
            var point = $(this);
            setTimeout(function () {
                point.removeClass('slideInDown1').addClass('animated slideOutDown1');
            }, i * 280);
        })
    }
});

// scrollToBlock($('.partnership__key-numbers_list'), function (isIn){
//     if(isIn){
//         numCounter();
//     }
// })
//
// function numCounter(){
//     $('.count-value').each(function () {
//         let $this = $(this);
//         let getDataVal = parseFloat($this.data('val'));
//         let decimals = (getDataVal.toString().split('.')[1] || '').length;
//
//         jQuery({ Counter: 0 }).animate({ Counter: getDataVal }, {
//             duration: 2500,
//             easing: 'swing',
//             step: function () {
//                 $this.text(this.Counter.toFixed(decimals));
//             }
//         });
//     });
// }

function initNumberCounters() {
	const counters = document.querySelectorAll('.count-value');
	if (!counters.length) return;

	const animateValue = (el, start, end, duration, decimals, suffix = '') => {
		const startTime = performance.now();

		const tick = (now) => {
			const progress = Math.min((now - startTime) / duration, 1);
			const value = start + (end - start) * progress;
			el.textContent = value.toFixed(decimals) + suffix;

			if (progress < 1) {
				requestAnimationFrame(tick);
			}
		};

		requestAnimationFrame(tick);
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const el = entry.target;
			const dataVal = el.dataset.val;
			if (!dataVal) return;

			const hasPercent = dataVal.includes('%');
			const cleanVal = parseFloat(dataVal.replace(/[,%]/g, '')) || 0;
			const decimals = (cleanVal.toString().split('.')[1] || '').length;
			const suffix = hasPercent ? '%' : '';

			if (entry.isIntersecting) {
				// запустити анімацію
				animateValue(el, 0, cleanVal, 2600, decimals, suffix);
			} else {
				// скинути, щоб при повторній появі знову стартував
				el.textContent = '0' + suffix;
			}
		});
	}, { threshold: 0.17 });

	counters.forEach(el => observer.observe(el));
}


initNumberCounters();

// === integrations page === //
scrollToBlock($('#hero-section'), function (isIn) {
    var $smoothNav = $('.integrations__fixed-nav');

    if (isIn) {
        $smoothNav.addClass('is-invisible');
    } else {
        $smoothNav.removeClass('is-invisible');
    }
});

// ===== Scroll to Top ====
document.addEventListener('scroll', function () {
    if ($(window).scrollTop() >= 200) {
        $('#scroll-to-top').addClass('in');
    } else {
        $('#scroll-to-top').removeClass('in');
    }
}, {passive: true});

$('#scroll-to-top').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
        scrollTop: 0
    }, 500);
});

// Accept payments management carousel
var $carousel = $('.ap-management__carousel');
var $line = $carousel.find('.ap-management__line');

if ($carousel.length > 0) {
    $line.each(function (index, el) {
        $(this).clone().addClass('cloned').insertAfter(this);
    });
}

function _t(key, options) {
    let debugLang = true;
    let str = key;
    if ((typeof LANG != 'undefined') && LANG[key]) {
        str = LANG[key];
    } else if (debugLang) {
        console.warn('Lang key missing', key);
    }

    if (options !== undefined) {
        for (let k in options) {
            if (options.hasOwnProperty(k)) {
                let v = options[k];
                str = (str + '').replace('%' + k + '%', v);
            }
        }
    }

    return str;
}

if (getMode() == 'tablet' || getMode() == 'desktop' ) {
    scrollToBlock($('#covid-letter-block'), '', 150);
}

// when user select theme on main page after redirect to Booking templates page scroll to customizer and select chosen selected theme
let themesList = $('#templates .templates-list__item .btn--select-theme')
if( $(themesList).length ){
    themesList.on('click', function () {
        var selectedThemeName = $(this).data('theme-id');
        //console.log('rewrite input val');
        localStorage.setItem('selectedTheme', selectedThemeName );
    })
}
var localStorageData = localStorage.getItem('selectedTheme');
if( $('.templates-items--section').length ){
    let themesList = $( '.templates-items--section .templates-items--list-item') // таких айтемів багато
    var selectedButton = themesList.filter(function(){
        return $(this).find('.anchor-link').data('theme-id') == localStorageData;
    }).find('.anchor-link');


    $( document ).ready(function() {
        //console.log( "ready!" );
        setTimeout(function () {
            selectedButton.trigger('click');
            localStorage.removeItem('selectedTheme');
        }, 1500);
    });
}

function setWithExpiry(key, value, ttl) {
    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + (ttl), // (ttl * 24 * 60 * 60 * 1000) - use for days, now in seconds
    }
    localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

$('#sb_ExitPopup').on('hidden.bs.modal', function () {
    //setWithExpiry('sm_popup_banner', 1, 6000);
    localStorage.setItem('sm_popup_banner', '1');
});

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}


$(document).ready(function() {
    // let $sb_vs_sm = $('.sb-vs-sm__main-section');
	//
    // $(document).bind('mouseleave', function (e) {
    //     let $sb_widget = $('.simplybook-widget-container');
    //     let $sb_widget__open = false;
    //     if ($($sb_widget).length != 0) {
    //         if ($($sb_widget).hasClass('active')) {
    //             $sb_widget__open = !$sb_widget__open;
    //         }
    //     }
	//
    //     let $live_help = $('.i-embedded-form:visible');
    //     let $live_help__open = false;
    //     if ($($live_help).length) {
    //         $live_help__open = !$live_help__open;
    //     }
	//
    //     let $all_modals = $('.modal:not(#sb_ExitPopup)');
    //     let all_modal_isOpen = false;
    //     if( $($all_modals).hasClass('in') ){
    //         all_modal_isOpen = !all_modal_isOpen;
    //     }
	//
    //     //console.log( 'all modal = ', all_modal_isOpen );
    //     if (window.appLocale === 'en') {
    //         if ($sb_vs_sm.length == 0 && $sb_widget__open == false && $live_help__open == false && all_modal_isOpen == false) { // detect if we on not SB&SM page, enterprise widget is open, live chat is open, some popup is open
    //             if (e.pageY - $(window).scrollTop() <= 0.1) {
    //                 let hasPopup = $('#sb_ExitPopup');
    //                 if (hasPopup.length) {
    //                     //const status = getWithExpiry('sm_popup_banner', 1);
    //                     const status = localStorage.getItem('sm_popup_banner');
    //                     //console.log('status = ', status);
    //                     if (status != '1') {
    //                         $('#sb_ExitPopup').modal('show');
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // });

    //hide cookie banner for Igor's pages & Michail's pages
    if (window.location.href.indexOf("igor.d") > -1 || window.location.href.indexOf("memosh.dev18") > -1) {
        //$('.sb-important').fadeOut(); // $('.cookies').fadeOut();
    }

	function faqAccordionInit() {
		const toggles = document.querySelectorAll('.masonry-grid--item-toggler');
		toggles.forEach(toggle => {
			const controlledId = toggle.getAttribute('aria-controls');
			const content = document.getElementById(controlledId);

			// Plain max-height transition (mirrors accordion.js) instead of jQuery
			// slideDown/slideUp, so opening/closing never depends on jQuery's own
			// reflow timing interacting with content-visibility/beforematch.
			// `instant` skips the height animation and jumps straight to the fully-open
			// state — used for the beforematch/Find-in-Page reveal path, where the browser
			// calls its own scrollIntoView() synchronously right after the handler returns;
			// an animation still in flight at that point scrolls to a layout that's about
			// to change underneath it (landing short, or cropped under the sticky header).
			const openFAQ = (instant = false) => {
				if (content.classList.contains('expanded')) return;
				toggle.setAttribute('aria-expanded', 'true');
				toggle.classList.add('--active');
				content.removeAttribute('hidden');
				content.setAttribute('aria-hidden', 'false');
				content.classList.add('expanded');
				if (instant) {
					content.style.maxHeight = 'none';
				} else {
					requestAnimationFrame(() => {
						if (content.classList.contains('expanded')) {
							content.style.maxHeight = content.scrollHeight + 'px';
						}
					});
				}
			};

			const closeFAQ = () => {
				if (!content.classList.contains('expanded')) return;
				const collapse = () => {
					content.classList.remove('expanded');
					content.style.maxHeight = '0px';
				};
				// A fully-open panel has max-height released to "none" (see the transitionend
				// listener below) — CSS can't transition away from "none", so restore the exact
				// pixel height first (while .expanded/padding is still applied). A single rAF
				// after that still lands in the same unpainted frame as this synchronous write,
				// so a second rAF is needed to force a real paint of the restored height first —
				// otherwise the collapse to 0 is an unanimatable jump instead of a transition.
				if (content.style.maxHeight === 'none') {
					content.style.maxHeight = content.scrollHeight + 'px';
					requestAnimationFrame(() => requestAnimationFrame(collapse));
				} else {
					requestAnimationFrame(collapse);
				}
				toggle.setAttribute('aria-expanded', 'false');
				toggle.classList.remove('--active');
				content.setAttribute('aria-hidden', 'true');
				content.setAttribute('hidden', 'until-found');
			};

			const toggleFAQ = () => {
				if (content.classList.contains('expanded')) {
					closeFAQ();
				} else {
					openFAQ();
				}
			};

			toggle.addEventListener('click', e => {
				e.preventDefault();
				toggleFAQ();
			});

			toggle.addEventListener('keydown', e => {
				if (['Enter', ' '].includes(e.key)) {
					e.preventDefault();
					toggleFAQ();
				}
			});

			// Browser find-in-page reveals hidden="until-found" content on its own;
			// this just syncs our aria/--active state and reveals it instantly (see openFAQ).
			content.addEventListener('beforematch', () => openFAQ(true));

			// Once the open transition finishes, release the height cap entirely so later
			// content/viewport changes are never clipped by a stale (or guessed) max-height.
			content.addEventListener('transitionend', e => {
				if (e.propertyName === 'max-height' && content.classList.contains('expanded')) {
					content.style.maxHeight = 'none';
				}
			});

			const header = toggle.closest('.masonry-grid--item-header');
			if (header) {
				header.addEventListener('click', e => {
					if (!toggle.contains(e.target)) {
						e.preventDefault();
						toggleFAQ();
					}
				});
			}
		});
	}
	faqAccordionInit();

	function toggleKeyBenefitsView() {
		const $section = $('.key-benefits.collapsible');

		if ($section.length ) {
			const $items = $section.find('.key-benefits__col');
			const $toggler = $section.find('.key-benefits__col-toggler');
			const $toggleBtn = $toggler.find('.toggle-view-items');
			const itemsToShowInitially = 2;

			if ($items.length > itemsToShowInitially) {
				// Show only first N items
				$items.each(function (index) {
					$items.each(function (index) {
						if (index <= itemsToShowInitially) {
							$(this).addClass('key-benefits__col--visible');
						} else {
							$(this).hide().addClass('key-benefits__col--hidden');
						}
					});
				});

				// Show the toggle block
				$toggler.removeClass('hidden');

				// Handle toggle click
				$toggleBtn.on('click', function () {
					const isExpanded = $section.hasClass('key-benefits--expanded');

					$(this).toggleClass('expanded');

					if (isExpanded) {
						// Collapse view - hide extras
						$items.each(function (index) {
							if (index > itemsToShowInitially) {
								$(this).slideUp();
							}
						});
						$section.removeClass('key-benefits--expanded');
					} else {
						// Expand view - show all
						$items.slideDown();
						$section.addClass('key-benefits--expanded');
					}
				});
			}
		}
	}

	toggleKeyBenefitsView();

});



/**
 * Waits until selector appears in DOM, then runs callback ONCE.
 * Works for SSR, delayed Twig includes, React mounts, etc.
 */
function runWhenReady(selector, callback, options = {}) {
	const { once = true, maxWait = 4000 } = options;
	if (document.querySelector(selector)) {
		callback();
		return;
	}

	let done = false;
	const observer = new MutationObserver(() => {
		if (done) return;
		if (document.querySelector(selector)) {
			if (once) done = true;
			observer.disconnect();
			callback();
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });

	// optional timeout safeguard
	setTimeout(() => {
		if (!done && document.querySelector(selector)) {
			callback();
			observer.disconnect();
		}
	}, maxWait);
}

/**
 * Safe DOM ready
 */
function onDOMReady(fn) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		fn();
	}
}

/**
 * ================================
 *  ACCESSIBILITY COMPONENTS
 * ================================
 */

// Tooltip keyboard navigation
function tooltipKeyboardNav() {
	const tooltips = document.querySelectorAll('.tooltip-component');
	if (!tooltips.length) return;

	tooltips.forEach(el => {
		el.setAttribute('tabindex', '0'); // allow keyboard focus if not button
		el.addEventListener('keydown', e => {
			if (['Enter', ' '].includes(e.key)) {
				e.preventDefault();
				el.classList.toggle('is-active');
			}
		});
		el.addEventListener('focus', () => el.classList.add('is-active'));
		el.addEventListener('blur', () => el.classList.remove('is-active'));
		el.addEventListener('mouseleave', () => el.classList.remove('is-active'));
	});
}

/**
 * Unified dropdown control — supports hover, click and keyboard navigation
 * Keeps state consistent across input methods (mouse/keyboard)
 */
function mainMenuDropdownKeyboardNav() {
	const dropdowns = document.querySelectorAll('.dropdown');
	if (!dropdowns.length) return;

	// console.log(dropdowns) // P0-1: removed debug log

	dropdowns.forEach(dropdown => {
		const toggle = dropdown.querySelector('.dropdown-toggle, [data-dropdown]');
		const menu = dropdown.querySelector('.dropdown-menu');
		if (!toggle || !menu) return;

		const items = menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
		let isOpen = false;
		let isMouseInside = false;

		/** Opens the dropdown */
		const openMenu = () => {
			if (isOpen) return;
			menu.classList.add('is-visible');
			toggle.setAttribute('aria-expanded', 'true');
			isOpen = true;
			items.forEach(el => el.setAttribute('tabindex', '0'));
		};

		/** Closes the dropdown */
		const closeMenu = () => {
			if (!isOpen) return;
			menu.classList.remove('is-visible');
			toggle.setAttribute('aria-expanded', 'false');
			isOpen = false;
			items.forEach(el => el.setAttribute('tabindex', '-1'));
		};

		/** Toggle click (works for both <a> and <button>) */
		toggle.addEventListener('click', e => {
			// Prevent accidental navigation when closed
			if (!isOpen && toggle.tagName.toLowerCase() === 'a') e.preventDefault();
			isOpen ? closeMenu() : openMenu();
		});

		/** Keyboard control on toggle */
		toggle.addEventListener('keydown', e => {
			if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
				e.preventDefault();
				openMenu();
				setTimeout(() => {
					if (e.key === 'ArrowUp') items[items.length - 1]?.focus();
					else items[0]?.focus();
				}, 80);
			}
		});

		/** Keyboard navigation inside dropdown */
		menu.addEventListener('keydown', e => {
			const list = Array.from(items);
			const i = list.indexOf(document.activeElement);
			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault();
					list[(i + 1) % list.length]?.focus();
					break;
				case 'ArrowUp':
					e.preventDefault();
					list[(i - 1 + list.length) % list.length]?.focus();
					break;
				case 'Home':
					e.preventDefault();
					list[0]?.focus();
					break;
				case 'End':
					e.preventDefault();
					list[list.length - 1]?.focus();
					break;
				case 'Escape':
					e.preventDefault();
					closeMenu();
					toggle.focus();
					break;
			}
		});

		/** Hover open/close (synced with keyboard state) */
		dropdown.addEventListener('mouseenter', () => {
			isMouseInside = true;
			openMenu();
		});
		dropdown.addEventListener('mouseleave', () => {
			isMouseInside = false;
			setTimeout(() => {
				if (!isMouseInside && !dropdown.contains(document.activeElement)) closeMenu();
			}, 120);
		});

		/** Close on outside click */
		document.addEventListener('click', e => {
			if (!dropdown.contains(e.target)) closeMenu();
		});

		/** Close when focus truly leaves dropdown (fixes premature close on Tab) */
		dropdown.addEventListener('focusout', function (e) {
			// wait a tick so the next focused element is known
			setTimeout(function () {
				if (!dropdown.contains(document.activeElement) && !isMouseInside) {
					closeMenu();
				}
			}, 100);
		});

		// Remove from tab order initially
		items.forEach(el => el.setAttribute('tabindex', '-1'));
	});
}
onDOMReady(() => {
	// Register components to be initialized when ready
	runWhenReady('.tooltip-component', tooltipKeyboardNav);
	runWhenReady('.dropdown', mainMenuDropdownKeyboardNav);
});

